<template>
  <footer>
    <div class="links-wrapper">
      <section class="logo" aria-label="bubly sparkling water logo">
        <icon :link="Logo"></icon>
      </section>
      <section class="links">
        <sitemap/>
      </section>
    </div>
    <section class="social">
      <div class="social-content">
        <p>introducing <span><icon :link="LogoClean"></icon></span>,</p> 
        <p>a new sparkling water</p>
        <social/>
      </div>
    </section>
  </footer>
</template>

<script>
  import Social from '@/components/common/Social';
  import Sitemap from '@/components/footer/Sitemap';
  import Icon from '@/components/custom-icons/Icon';
  import Logo from '@/assets/bubly-logo.svg';
  import LogoClean from '@/assets/bubly-logo-clean.svg';

  export default {
    name: 'bubly-footer',
    data() {
      return {
        Logo,
        LogoClean
      };
    },
    components: {
      Social,
      Sitemap,
      Icon,
    },
  };
</script>

<style lang='scss' scoped>
  @import './../variables.scss';

  footer {
    display: flex;
    flex-wrap: wrap;
    background-color: $bubly-blue;
    color: $bubly-white;
    font-size: rem(18);
    padding: 30px 15px 45px;

    .links-wrapper {
      width: 100%;
      position: relative;
      margin-bottom: 20px;
    }

    .logo, .links {
      width: 50%;
    }

    .logo {
      position: absolute; 
      left: 0;
      top: 50%;
      transform: translateY(-50%);
      svg {
        width: 60%;
        fill: $bubly-white;
      }
    }

    .links {
      float: right;
    }

    .social {
      width: 100%;
      p {
        margin: 6px 0;
        display: inline-block;
      }
      span {
        width: 50px;
        height: 18px;
        display: inline-block;
        position: relative;
      }
      svg {
        position: absolute;
        top: 0;
        left: 0;
        width: 50px;
        height: 26px;
        fill: #FFF;
      }
    }


    /* 
     * TABLET
     */

    @include breakpoint('tablet') {
      padding: 75px 70px 55px;
      // height: rem(375);
      box-sizing: border-box;

      .links-wrapper {
        width: 50%;
      }

      .social {
        width: 50%;
        &-content {
          text-align: right;
          position: relative;
          top: 50%;
          transform: translateY(-50%);
        }
        &-icons {
          align-items: flex-end;
          text-align: right;
          width: 100%;
        }
        p {
          display: block;
        }
      }
    }


    /* 
     * LAPTOP
     */

    @include breakpoint('laptop') {
      .social p {
        display: inline-block;
      }
    
    }
}

</style>



// WEBPACK FOOTER //
// src/components/BublyFooter.vue